<template>
    <div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item>
                <el-input v-model="queryParams.userName" placeholder="用户名" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="queryParams.phonenumber" placeholder="手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
        </el-form>
        <div style="margin-bottom:10px;">
            <el-button type="primary" plain icon="el-icon-plus" style="width:90px !important;color:#fff;" @click="addUser">添加用户</el-button>
            <el-button type="info" plain icon="el-icon-circle-close" style="width:120px !important;" @click="cancelAuthUserAll">批量取消授权</el-button>
        </div>
        <!-- 表格 -->
         <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" @selection-change="handleSelectionChange" class="custom-table-header">
            <el-table-column type="selection" width="50" align="center" />
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column label="用户账号" prop="userName" />
            <el-table-column label="用户名称" prop="nickName" />
            <el-table-column label="邮箱" prop="email" />
            <el-table-column label="手机" prop="phonenumber" />
            <el-table-column label="状态" align="center" prop="status" :formatter="formatter" />
            <el-table-column label="创建时间" align="center" prop="createTime" width="180" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="text" @click="cancelAuthUser(scope.row)" size="small" style="color:#3083FB !important;">取消授权</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>

        <!-- 选择用户 -->
        <select-user ref="selectRef" v-if="selectUserVisible" :role-id="queryParams.roleId" :selectUserVisible="selectUserVisible" @ok="handleQuery" @cancel="handelCancel"/>
    </div>
</template>
<script>
import selectUser from './selectUser';
import { Message, MessageBox} from 'element-ui'
export default {
    name: 'AssignUsers',
    props: {
        roleId: {
            type: String,
            required: true
        }
    },
    components:{
        selectUser
    },
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                userName:"",
                phonenumber:"",
                roleId:""
            },
            total:0,
            tableHeight:650,
            // 表格数据
            tableData:[],
            multipleSelection:[],//选中的数据
            selectUserVisible:false,
            userIds:""
        }
    },
    mounted() {
        this.queryParams.roleId = this.roleId;
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.getList();
    },
    methods: {
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH-200;//表单的高度会变化
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            tableBody.style.height = (this.tableHeight-40)+"px";
        },
        getList(){
            this.$store.dispatch('role/allocatedUserList', this.queryParams).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
            });
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                userName:"",
                phonenumber:"",
                roleId:""
            }
        },
        // 状态列格式
        formatter(row) {
            if(row.status==1){
                return "停用";
            }
            return "正常";
        },
        // 选择
        handleSelectionChange(selection){
            this.userIds = selection.map((item) => item.userId);
        },
        // 打开用户选择弹框
        addUser(){
            this.selectUserVisible = true;
        },
        // 行取消授权
        cancelAuthUser(row) {
            MessageBox.confirm('确认要取消该用户"' + row.userName + '"角色吗？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('role/authUserCancel',{ userId: row.userId, roleId: this.queryParams.roleId }).then((result)=>{
                    if(result){
                        this.getList();
                        Message.success('取消授权成功');
                    }
                }); 
            }).catch(() => {          
            });
            
        },
        // 批量取消授权
        cancelAuthUserAll(){
            const roleId = this.queryParams.roleId;
            if(this.userIds==''){
                Message.warning('请选择要取消授权的用户');
                return;
            }
            const uIds = this.userIds.join(',');
            MessageBox.confirm('是否取消选中用户授权数据项？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('role/authUserCancelAll',{ userIds: uIds, roleId}).then((result)=>{
                    if(result){
                        this.getList();
                        Message.success('取消授权成功');
                    }
                }); 
            }).catch(() => {          
            });
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        // 确认分配用户，子组件emit
        handleQuery(){
            this.selectUserVisible = false;
            this.onSubmit();
        },
        // 取消分配用户，子组件emit
        handelCancel(){
            this.selectUserVisible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
        // height: 100%;
        overflow-y: auto;
    }
</style>